/** Account-level access rules evaluated from imported collaborator attributes. */
export interface RoleCondition {
  filterName: string
  name: string
}

export class Role {
  id: string = ""
  AccountId: string | null = null
  name: string = ""
  // AND between filter names, OR between populations of the same filter.
  // Empty conditions must not grant access.
  conditions: RoleCondition[] = []
  // Match the member's own values for these attributes (AND between attributes).
  // Both scope lists empty grants access to the whole organization.
  // A missing member attribute needs a fixed alternative in the same filter.
  scopeFilterNames: string[] = []
  // Fixed populations shared by all members, combined with dynamic values.
  scopePopulations: RoleCondition[] = []
  // Nombre de membres, calcule par le serveur a partir des conditions.
  usersCount: number = 0

  constructor(item: Partial<Role> = {}) {
    Object.assign(this, item)
    this.conditions = (item.conditions ?? []).map(({ filterName, name }) => ({ filterName, name }))
    this.scopeFilterNames = [...(item.scopeFilterNames ?? [])]
    this.scopePopulations = (item.scopePopulations ?? []).map(({ filterName, name }) => ({ filterName, name }))
  }
}
